<!-- @file PC端答题卡-个人答题正误情况。 -->

<template>
  <div class="plv-iar-answer-card-correction-default">
    <template v-if="selfCorrection === 'selfRight'">
      <IconTipRight :size="60" color="#44c18c" />
      <div class="plv-iar-answer-card-correction-default__text">
        {{ iarTrans('answerCard.rightAnswerWords') }}
      </div>
    </template>
    <template v-else-if="selfCorrection === 'selfWrong'">
      <IconTipWrong :size="60" color="#fb7272" />
      <div class="plv-iar-answer-card-correction-default__text">
        {{ iarTrans('answerCard.wrongAnswerWords') }}
      </div>
    </template>
    <template v-else>
      <IconTipWarn :size="60" color="#ff8142" />
      <p class="plv-iar-answer-card-correction-default__text">{{ iarTrans('answerCard.notSubmittedTips') }}</p>
    </template>
  </div>
</template>

<script>
import mixin from './mixin';
import IconTipRight from '../../../icon-components/icons/icon-tip-right';
import IconTipWrong from '../../../icon-components/icons/icon-tip-wrong';
import IconTipWarn from '../../../icon-components/icons/icon-tip-warn';
export default {
  mixins: [mixin],
  components: {
    IconTipRight,
    IconTipWrong,
    IconTipWarn
  },
};
</script>

<style lang="scss">
.plv-iar-answer-card-correction-default {
  margin: 0 auto 20px;
  text-align: center;
}

.plv-iar-answer-card-correction-default__text {
  font-size: 14px;
  color: #333;
  text-align: center;
  line-height: 1;
  p {
    display: inline;
  }
  ::v-deep span {
    color: #45ACFF;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
